import { useEffect, useState } from 'react'
import { Link, Outlet } from 'react-router-dom'
import { AreaSidebar } from '@/components/ged/AreaSidebar'
import { SearchCommandPopup } from '@/components/ged/SearchCommandPopup'
import { useUser } from '@/contexts/UserContext'

export function Layout() {
  const { logout } = useUser()
  const [searchOpen, setSearchOpen] = useState(false)

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        setSearchOpen(true)
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [])

  return (
    <div className="ged-shell" data-density="comfortable" style={{ flexDirection: 'column' }}>
      <Topbar onLogout={logout} />
      <div style={{ flex: 1, display: 'flex', minHeight: 0 }}>
        <AreaSidebar onOpenSearch={() => setSearchOpen(true)} />
        <main
          style={{
            flex: 1,
            overflow: 'auto',
            background: 'var(--ev-bg-alt)',
          }}
        >
          <Outlet />
        </main>
      </div>
      <SearchCommandPopup open={searchOpen} onOpenChange={setSearchOpen} />
    </div>
  )
}

function Topbar({ onLogout }: { onLogout: () => Promise<void> }) {
  return (
    <header
      style={{
        height: 56,
        flexShrink: 0,
        background: '#1A1F24',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        display: 'flex',
        alignItems: 'center',
        padding: '0 18px',
        gap: 16,
      }}
    >
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
        <img
          src="/assets/banesprev-logo.png"
          alt="Banesprev"
          style={{ height: 23, width: 'auto' }}
          onError={(e) => {
            (e.currentTarget as HTMLImageElement).style.display = 'none'
          }}
        />
        <span
          style={{
            fontSize: 'var(--fs-small)',
            fontWeight: 500,
            letterSpacing: '0.02em',
            color: 'rgba(255,255,255,0.6)',
            borderLeft: '1px solid rgba(255,255,255,0.2)',
            paddingLeft: 10,
          }}
        >
          GED
        </span>
      </Link>
      <div style={{ flex: 1, minWidth: 0 }} />
      <button
        type="button"
        onClick={() => onLogout()}
        style={{
          background: 'none',
          border: 0,
          padding: '6px 4px',
          color: 'rgba(255,255,255,0.6)',
          fontSize: 'var(--fs-small)',
          fontWeight: 500,
          cursor: 'pointer',
        }}
      >
        Sair
      </button>
    </header>
  )
}
